<!-- eslint disable -->
<template>
    <div id="login-wrap">
        <header>
            <h1>
                <img src="./images/lhv2DA.png">
            </h1>
        </header>
        <main>
            <div id="loginBox">
                <div id="login" />
                <index-login-window
                    v-show="isLoginWindow"
                    :vuex-modeule-name="vuexModeuleName"
                />
            </div>
        </main>
    </div>
</template>
<script>
import indexLoginWindow from './components/indexLoginWindow'
import { setCookie } from '@/utils/index'
export default {
    components: {
        indexLoginWindow,
    },
    data () {
        return {
            vuexModeuleName: 'loginModule',
        }
    },
    computed: {
        isLoginWindow () {
            return this.$store.state[this.vuexModeuleName].isLoginWindow
        },
        isPwd () {
            return this.$store.state[this.vuexModeuleName].isPwd
        },
        isCompany () {
            return this.$store.state[this.vuexModeuleName].isCompany
        },
        loginData () {
            return this.$store.state[this.vuexModeuleName].loginData
        }
    },
    created () {
        if (window.location.search.includes('redirect=authentication')) {
            setCookie('redirect', 'authentication', window.location.host.substring(window.location.host.indexOf('.')))
        }
        this.$nextTick(() => {
            this.$store.commit(this.vuexModeuleName + '/updateStateData', {
                isLoginWindow: true
            })
        })
    },
}
</script>
<style lang="scss" scoped>
.login-cover-wrap {
    position: fixed;
    left: 0;
    width: 100%;
    height: 100%;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1;
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-active {
    opacity: 0;
}
#login-wrap {
    position: relative;
    overflow: auto;
    width: 100%;
    height: 100%;
}
header {
    padding: 0px;
    height: 70px;
    z-index: 2;
    overflow: hidden;
    background: rgba(255, 255, 255, 1);
    img {
        padding: 17px 40px;
        width: 100px;
        height: 36px;
    }
}
main {
    max-width: 100%;
    min-width: 1260px;
    width: 100%;
    height: auto;
}
#loginBox {
    max-width: 1200px;
    height: 720px;
    box-sizing: border-box;
    padding: 80px 0 80px;
    margin: 0 auto;
    clear: both;
}
#login {
    width: 550px;
    height: 100%;
    float: left;
    margin-right: 50px;
    a {
        display: block;
        width: 550px;
        height: 100%;
        cursor: pointer;
    }
}

.login-window {
    float: right;
    overflow: hidden;
}
footer {
    font-size: 14px;
    font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei',
        '微软雅黑', Arial, sans-serif;
    font-weight: 400;
    color: rgba(109, 114, 120, 1);
    line-height: 70px;
    p {
        background: rgba(255, 255, 255, 1);
        text-align: center;
    }
}

@media screen and (max-width: 1680px) {
    #login .login-window {
        right: 10%;
    }
}
</style>
